module.exports = __webpack_public_path__ + "static/media/AttentionIcon.d9fb5cbe.svg";